import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getPaymentAccountsAction, getQuickpayAction, getQuickpayAutopaysAction, getQuickpayStatusAction } from 'actions/quickpay';
import Loader from 'components/Loader';

import { get } from 'lodash';
import styles from './styles.module.scss';

const Landing = ({ location }) => {
  const { uid } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState('');

  const handleError = (err) => {
    if (get(err, 'data.code') === 'TOKEN_EXPIRED') {
      history.push('/quickpay/link-expired');
    } else {
      setErrorMsg(get(err, 'data.message') || 'An error occurred');
    }
  };

  useEffect(() => {
    const refreshData = () => {
      if (history.location.pathname === '/quickpay/simple-pay') {
        history.push(`/quickpay/${uid}`);
      }
    };

    window.addEventListener('popstate', refreshData);
  }, []);

  useEffect(() => {
    if (uid) {
      dispatch(getQuickpayAction({
        uid,
        success: () => {
          dispatch(getPaymentAccountsAction({
            success: (accounts) => {
              dispatch(getQuickpayStatusAction({
                success: () => {
                  let goToUrl = '/quickpay/add-payment-method';
                  const from = get(location, 'state.from.pathname');
                  if (from) {
                    goToUrl = from;
                  } else if (accounts.length > 0) {
                    goToUrl = '/quickpay/simple-pay';
                  }
                  history.push(goToUrl);
                  dispatch(getQuickpayAutopaysAction());
                },
                fail: handleError,
              }));
            },
            fail: handleError,
          }));
        },
        fail: handleError,
      }));
    }
  }, []);

  return (
    <div className={styles.loader}>
      {errorMsg || <Loader className="height-2" />}
    </div>
  );
};

Landing.propTypes = {
  location: PropTypes.object.isRequired,
};

export default Landing;
